import { render, staticRenderFns } from "./nets.vue?vue&type=template&id=256c3262&"
import script from "./nets.vue?vue&type=script&lang=js&"
export * from "./nets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports